import { SearchFilter } from '../../types';

export interface DurationFilterProps extends SearchFilter {
  className?: string;
}

export enum LimitType {
  MIN,
  MAX,
}

export enum TimeType {
  YEAR,
  MONTH,
}
